module.exports = __webpack_public_path__ + "img/IILM.0808b88a.jpg";